module.exports = __webpack_public_path__ + "img/GeraltOfRivia.ffe1b99.png";